import { ensureNativeModulesAreInstalled } from './ensureNativeModulesAreInstalled';
ensureNativeModulesAreInstalled();
export default globalThis.expo.NativeModule;
//# sourceMappingURL=NativeModule.js.map